export default __webpack_public_path__ + "static/media/snuffles-string.29f87c4c.png";